// extracted by mini-css-extract-plugin
module.exports = {"figure":"TextImageSection_figure__loJqc","image":"TextImageSection_image__2_L_W","keepAspectRatio":"TextImageSection_keepAspectRatio__XIPqs"};